"use client";

import RichText from "@blocks/RichText/RichText";
import { Heading, Paragraph } from "@components/ui";
import NewCustomerForm from "@forms/newCustomer";
import type { FormPageQuery } from "@server/gql/graphql";
import { useSearchParams } from "next/navigation";
import type { Dictionary } from "types/common";

export default function Wrapper({
  dictionary,
  page,
  market,
  locale,
}: {
  dictionary: Dictionary;
  page: FormPageQuery["page"];
  market: string;
  locale: string | undefined;
}) {
  const searchParams = useSearchParams();
  if (!page) return null;
  const { title, subtitle, ingress } = page;
  const [heading = "", subheading = ""] = title?.split("?") ?? [];

  if (searchParams.has("success"))
    return (
      <Heading
        as="h1"
        size={4}
        className="max-w-content place-self-center self-center"
      >
        {dictionary.newCustomerFormSuccessHeading}
        <br />
        {dictionary.newCustomerFormSuccessText}
      </Heading>
    );
  return (
    <>
      <Heading as="h1" size={4} className="max-w-content">
        {heading}?<br />
        {subheading}
      </Heading>
      <Paragraph size="small" className="max-w-content">
        {subtitle}
      </Paragraph>
      <NewCustomerForm dictionary={dictionary} />
      {ingress && (
        <RichText
          className="text-xxs text-gray-400"
          content={ingress}
          market={market}
          locale={locale}
        />
      )}
    </>
  );
}
